import script from "./Dishes.vue?vue&type=script&setup=true&lang=js"
export * from "./Dishes.vue?vue&type=script&setup=true&lang=js"

import "./Dishes.vue?vue&type=style&index=0&id=32f5fa2e&lang=css"

const __exports__ = script;

export default __exports__